// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=Plus+Jakarta+Sans:ital,wght@0,200..800;1,200..800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Updated responsive FaceRecognition styles */
.tryAgainButton {
    margin-top: 16px;
    padding: 10px 28px;
    background: linear-gradient(90deg, rgba(59,179,174,0.6) 0%, rgba(72,209,204,0.6) 100%);
    color: #fff;
    border: none;
    border-radius: 24px;
    font-size: 1rem;
    font-weight: 600;
    cursor: pointer;
    box-shadow: 0 2px 8px rgba(59,179,174,0.15);
    transition: background 0.2s, transform 0.2s, box-shadow 0.2s;
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    border: 1.5px solid rgba(255,255,255,0.25);
}

.tryAgainButton:hover, .tryAgainButton:focus {
    background: linear-gradient(90deg, rgba(72,209,204,0.7) 0%, rgba(59,179,174,0.7) 100%);
    transform: translateY(-2px) scale(1.04);
    box-shadow: 0 4px 16px rgba(59,179,174,0.25);
    outline: none;
}

.blueCornersOverlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none; /* Allow clicks to pass through */
}
.corner {
    position: absolute;
    /* Scales with viewport but kept within sensible limits */
    width: clamp(48px, 6vw, 140px);
    height: clamp(48px, 6vw, 140px);
    border: 3px solid #00ffff; /* Bright blue */
    box-sizing: border-box;
}

.top-left {
    top: 5%;
    left: 5%;
    border-right: none;
    border-bottom: none;
    border-top-left-radius: 10px;
}

/* Top-right */
.top-right {
    top: 5%;
    right: 5%;
    border-left: none;
    border-bottom: none;
    border-top-right-radius: 10px;
}

/* Bottom-left */
.bottom-left {
    bottom: 5%;
    left: 5%;
    border-right: none;
    border-top: none;
    border-bottom-left-radius: 10px;
}

/* Bottom-right */
.bottom-right {
    bottom: 5%;
    right: 5%;
    border-left: none;
    border-top: none;
    border-bottom-right-radius: 10px;
}

.faceRecognitionContainer {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #FFF;
    height: 100%;
    width: 100%;
}

.faceRecognitionHeaderContainer {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.faceRecognitionFooterContainer {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
}

.faceRecognitionHeaderText {
    font-family: "Inter", sans-serif;
    text-align: center;
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: 32px;
}

.faceRecognitionSubText {
    margin-top: 10px;
    font-family: "Plus Jakarta Sans", sans-serif;
    text-align: center;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    text-transform: capitalize;
}
.faceRecognitionVideoContainer{
    position: relative;
    margin: 2vh auto;
    /* Responsive width with min/max and maintain an aspect ratio */
    width: clamp(320px, 60vw, 1200px);
    max-width: 95%;
    aspect-ratio: 16 / 9;
    max-height: 80vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0,0,0,0.06);
    border-radius: 12px;
    overflow: hidden;
}
.faceRecognitionImage{
    height: 100%;
    width: 100%;
}
.faceErrorContainer{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
}
.faceRecognitionFooterText1 {
    text-align: center;
    font-family: Inter;
    font-size: 22px;
    font-style: normal;
    font-weight: 500;
    line-height: 25px;
    letter-spacing: -0.4px;
    text-transform: capitalize;
}

.faceRecognitionFooterText2 {
    color: #C6C6C6;
    text-align: center;
    font-family: Inter;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    letter-spacing: -0.4px;
}

.errorMessage {
    color: #ff4d4d;
    text-align: center;
    padding: 18px;
    font-family: "Poppins", sans-serif;
    font-size: 14px;
    line-height: 1.5;
    background-color: rgba(255, 77, 77, 0.08);
    border-radius: 10px;
    margin: 2vh auto;
    overflow: hidden;
    max-width: 880px;
    width: calc(100% - 40px);
}
.faceErrorMessage{
    color: white;
    text-align: center;
    padding: 16px;
    font-family: "Poppins", sans-serif;
    font-size: 1.05rem;
    line-height: 1.4;
    background-color: rgba(255, 77, 77, 0.08);
    border-radius: 10px;
    width: min(92%, 760px);
    overflow: hidden;
}

.faceRecognitionVideoContainer video {
    display: block !important;
    width: 100% !important;
    height: 100% !important;
    object-fit: cover; /* preserve aspect ratio while filling container */
    transform: scaleX(-1);
    border-radius: 12px;
}

/* Simplified responsive adjustments for small screens */
@media (max-width: 480px) {
    .faceRecognitionVideoContainer{
        width: calc(100vw - 32px);
        aspect-ratio: 4 / 3;
        margin: 16px auto;
        border-radius: 10px;
    }
    .faceErrorMessage{
        font-size: 0.95rem;
        padding: 12px;
    }
    .tryAgainButton {
        padding: 8px 18px;
        font-size: 0.95rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/Components/FaceRecognition/FaceRecognition.css"],"names":[],"mappings":"AAAA,8CAA8C;AAC9C;IACI,gBAAgB;IAChB,kBAAkB;IAClB,sFAAsF;IACtF,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,2CAA2C;IAC3C,4DAA4D;IAC5D,0BAA0B;IAC1B,kCAAkC;IAClC,0CAA0C;AAC9C;;AAEA;IACI,sFAAsF;IACtF,uCAAuC;IACvC,4CAA4C;IAC5C,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oBAAoB,EAAE,iCAAiC;AAC3D;AACA;IACI,kBAAkB;IAClB,yDAAyD;IACzD,8BAA8B;IAC9B,+BAA+B;IAC/B,yBAAyB,EAAE,gBAAgB;IAC3C,sBAAsB;AAC1B;;AAEA;IACI,OAAO;IACP,QAAQ;IACR,kBAAkB;IAClB,mBAAmB;IACnB,4BAA4B;AAChC;;AAEA,cAAc;AACd;IACI,OAAO;IACP,SAAS;IACT,iBAAiB;IACjB,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA,gBAAgB;AAChB;IACI,UAAU;IACV,QAAQ;IACR,kBAAkB;IAClB,gBAAgB;IAChB,+BAA+B;AACnC;;AAEA,iBAAiB;AACjB;IACI,UAAU;IACV,SAAS;IACT,iBAAiB;IACjB,gBAAgB;IAChB,gCAAgC;AACpC;;AAKA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,gCAAgC;IAChC,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,4CAA4C;IAC5C,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,0BAA0B;AAC9B;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,+DAA+D;IAC/D,iCAAiC;IACjC,cAAc;IACd,oBAAoB;IACpB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,4BAA4B;IAC5B,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;AACb;AACA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,0BAA0B;AAC9B;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,yCAAyC;IACzC,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,wBAAwB;AAC5B;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,kCAAkC;IAClC,kBAAkB;IAClB,gBAAgB;IAChB,yCAAyC;IACzC,mBAAmB;IACnB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,uBAAuB;IACvB,iBAAiB,EAAE,kDAAkD;IACrE,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA,wDAAwD;AACxD;IACI;QACI,yBAAyB;QACzB,mBAAmB;QACnB,iBAAiB;QACjB,mBAAmB;IACvB;IACA;QACI,kBAAkB;QAClB,aAAa;IACjB;IACA;QACI,iBAAiB;QACjB,kBAAkB;IACtB;AACJ","sourcesContent":["/* Updated responsive FaceRecognition styles */\n.tryAgainButton {\n    margin-top: 16px;\n    padding: 10px 28px;\n    background: linear-gradient(90deg, rgba(59,179,174,0.6) 0%, rgba(72,209,204,0.6) 100%);\n    color: #fff;\n    border: none;\n    border-radius: 24px;\n    font-size: 1rem;\n    font-weight: 600;\n    cursor: pointer;\n    box-shadow: 0 2px 8px rgba(59,179,174,0.15);\n    transition: background 0.2s, transform 0.2s, box-shadow 0.2s;\n    backdrop-filter: blur(8px);\n    -webkit-backdrop-filter: blur(8px);\n    border: 1.5px solid rgba(255,255,255,0.25);\n}\n\n.tryAgainButton:hover, .tryAgainButton:focus {\n    background: linear-gradient(90deg, rgba(72,209,204,0.7) 0%, rgba(59,179,174,0.7) 100%);\n    transform: translateY(-2px) scale(1.04);\n    box-shadow: 0 4px 16px rgba(59,179,174,0.25);\n    outline: none;\n}\n\n.blueCornersOverlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    pointer-events: none; /* Allow clicks to pass through */\n}\n.corner {\n    position: absolute;\n    /* Scales with viewport but kept within sensible limits */\n    width: clamp(48px, 6vw, 140px);\n    height: clamp(48px, 6vw, 140px);\n    border: 3px solid #00ffff; /* Bright blue */\n    box-sizing: border-box;\n}\n\n.top-left {\n    top: 5%;\n    left: 5%;\n    border-right: none;\n    border-bottom: none;\n    border-top-left-radius: 10px;\n}\n\n/* Top-right */\n.top-right {\n    top: 5%;\n    right: 5%;\n    border-left: none;\n    border-bottom: none;\n    border-top-right-radius: 10px;\n}\n\n/* Bottom-left */\n.bottom-left {\n    bottom: 5%;\n    left: 5%;\n    border-right: none;\n    border-top: none;\n    border-bottom-left-radius: 10px;\n}\n\n/* Bottom-right */\n.bottom-right {\n    bottom: 5%;\n    right: 5%;\n    border-left: none;\n    border-top: none;\n    border-bottom-right-radius: 10px;\n}\n\n@import url(\"https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=Plus+Jakarta+Sans:ital,wght@0,200..800;1,200..800&display=swap\");\n\n.faceRecognitionContainer {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    color: #FFF;\n    height: 100%;\n    width: 100%;\n}\n\n.faceRecognitionHeaderContainer {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n.faceRecognitionFooterContainer {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n}\n\n.faceRecognitionHeaderText {\n    font-family: \"Inter\", sans-serif;\n    text-align: center;\n    font-size: 24px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 32px;\n}\n\n.faceRecognitionSubText {\n    margin-top: 10px;\n    font-family: \"Plus Jakarta Sans\", sans-serif;\n    text-align: center;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 24px;\n    text-transform: capitalize;\n}\n.faceRecognitionVideoContainer{\n    position: relative;\n    margin: 2vh auto;\n    /* Responsive width with min/max and maintain an aspect ratio */\n    width: clamp(320px, 60vw, 1200px);\n    max-width: 95%;\n    aspect-ratio: 16 / 9;\n    max-height: 80vh;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: rgba(0,0,0,0.06);\n    border-radius: 12px;\n    overflow: hidden;\n}\n.faceRecognitionImage{\n    height: 100%;\n    width: 100%;\n}\n.faceErrorContainer{\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n}\n.faceRecognitionFooterText1 {\n    text-align: center;\n    font-family: Inter;\n    font-size: 22px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 25px;\n    letter-spacing: -0.4px;\n    text-transform: capitalize;\n}\n\n.faceRecognitionFooterText2 {\n    color: #C6C6C6;\n    text-align: center;\n    font-family: Inter;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n    letter-spacing: -0.4px;\n}\n\n.errorMessage {\n    color: #ff4d4d;\n    text-align: center;\n    padding: 18px;\n    font-family: \"Poppins\", sans-serif;\n    font-size: 14px;\n    line-height: 1.5;\n    background-color: rgba(255, 77, 77, 0.08);\n    border-radius: 10px;\n    margin: 2vh auto;\n    overflow: hidden;\n    max-width: 880px;\n    width: calc(100% - 40px);\n}\n.faceErrorMessage{\n    color: white;\n    text-align: center;\n    padding: 16px;\n    font-family: \"Poppins\", sans-serif;\n    font-size: 1.05rem;\n    line-height: 1.4;\n    background-color: rgba(255, 77, 77, 0.08);\n    border-radius: 10px;\n    width: min(92%, 760px);\n    overflow: hidden;\n}\n\n.faceRecognitionVideoContainer video {\n    display: block !important;\n    width: 100% !important;\n    height: 100% !important;\n    object-fit: cover; /* preserve aspect ratio while filling container */\n    transform: scaleX(-1);\n    border-radius: 12px;\n}\n\n/* Simplified responsive adjustments for small screens */\n@media (max-width: 480px) {\n    .faceRecognitionVideoContainer{\n        width: calc(100vw - 32px);\n        aspect-ratio: 4 / 3;\n        margin: 16px auto;\n        border-radius: 10px;\n    }\n    .faceErrorMessage{\n        font-size: 0.95rem;\n        padding: 12px;\n    }\n    .tryAgainButton {\n        padding: 8px 18px;\n        font-size: 0.95rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
